import styled from "styled-components";

export const RootContainer = styled.div`
  position: relative;

  .ant-table-wrapper {
    margin: 82px 16px 24px 16px;
  }
`;

export const Top = styled.div`
  position: relative;
  z-index: 1;

  text-align: center;
  padding-top: 50px;
`;

export const LightText = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: #ffcfe9;
`;

export const Text = styled.div`
  padding-top: 12px;
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
`;

export const Table = styled.div`
  display: table;
  width: 93%;
  margin: 90px 16px 0px 16px;
  table-layout: fixed;
  max-height: 100px;
`;

export const TableHeading = styled.div`
  display: table-row;
  position: sticky;
  top: 0;
  background-color: #71207c;
  z-index: 1;

  > div:first-child {
    width: 60px;
  }

  @media screen and (max-width: 330px) {
    > div:first-child {
      width: 20px;
    }
  }
`;

export const TableRow = styled.div`
  display: table-row;
  background-color: #f1f1f1;
  :nth-of-type(odd) {
    background-color: #e1cce0;
  }
`;

export const TableHeadingCell = styled.div`
  display: table-cell;
  padding: 13px 5px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  :first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  :last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  @media screen and (max-width: 365px) {
    font-size: 12px;
  }
  @media screen and (max-width: 330px) {
    padding: 8px 1px;
  }
`;

export const TableCell = styled.div`
  display: table-cell;
  padding: 13px 5px;
  text-align: center;
  color: #000;
  font-size: 14px;
  :first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  :last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  @media screen and (max-width: 365px) {
    font-size: 12px;
  }
  @media screen and (max-width: 330px) {
    padding: 8px 1px;
  }
`;

export const SpinWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
`;
